(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
      window.matchMedia('(max-width: 990px)').addEventListener('change', () => {
        document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
      });
      this.setupMobileNav();
    }

    setupMobileNav() {
      const hamburger = this.querySelector('[data-rt-hamburger]');
      const drawer = document.getElementById('rt-nav-drawer');
      if (!hamburger || !drawer) return;

      const closeEls = drawer.querySelectorAll('[data-rt-nav-close]');

      const open = (event) => {
        drawer.toggleAttribute('data-keyboard-open', event.detail === 0);
        drawer.inert = false;
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        hamburger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        drawer.querySelector('button[data-rt-nav-close]')?.focus({ preventScroll: true });
      };

      const close = (returnFocus = true) => {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        hamburger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        if (returnFocus) hamburger.focus({ preventScroll: true });
        drawer.inert = true;
      };

      hamburger.addEventListener('click', (event) => {
        if (drawer.classList.contains('is-open')) { close(); } else { open(event); }
      });
      closeEls.forEach((el) => el.addEventListener('click', () => close()));
      drawer.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => close(false)));
      drawer.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          drawer.setAttribute('data-keyboard-open', '');
          close();
        }
        if (event.key !== 'Tab') return;
        const focusable = [...drawer.querySelectorAll('a[href], button:not([disabled])')];
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first?.focus();
        }
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rt-packs"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-rt-start-sub]');
    if (!btn) return;
    const target = document.getElementById('hero-offer') || document.getElementById('offer');
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    window.setTimeout(function () {
      const toggle = target.querySelector('[data-rt-sub-toggle]');
      if (toggle && !toggle.classList.contains('is-selected')) toggle.click();
    }, 500);
  });

  } catch(e) { console.error(e); }
})();
})();
